import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

import { ConfirmComponent } from './confirm.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ConfirmBottomComponent } from './confirm-bottom.component';

@Injectable()
export class ConfirmService {
  constructor(
    readonly bottomSheet: MatBottomSheet,
    private dialog: MatDialog) {
  }

  public confirm(data?: DataConfirm): Observable<boolean> {
    const nData = {
      theme: data?.theme,
      title: data?.title || 'Confirmar',
      message: data?.message || 'Você tem certeza?',
      buttonConfirm: data?.buttonConfirm ?? {
        label: 'Ok',
        show: true
      },
      buttonCancel: data?.buttonCancel || {
        label: 'Cancelar',
        show: true
      }
    };
    let dialogRef: MatDialogRef<ConfirmComponent>;
    dialogRef = this.dialog.open(ConfirmComponent, {
      width: '500px',
      disableClose: data.disableClose ?? true,
      data: nData
    });
    return dialogRef.afterClosed();
  }

  public confirmBottom(data?: DataConfirm): Observable<boolean> {
    const nData = {
      icon: data?.icon,
      theme: data?.theme,
      title: data?.title || 'Confirmar',
      message: data?.message || 'Você tem certeza?',
      messageDisable: data?.messageDisable,
      formConfig: data?.formConfig,
      buttonConfirm: data?.buttonConfirm ?? {
        label: 'Ok',
        show: true
      },
      buttonCancel: data?.buttonCancel || {
        label: 'Cancelar',
        show: true
      }
    };

    const bottomSheetRef = this.bottomSheet.open(ConfirmBottomComponent, {
      data: nData
    });
    return bottomSheetRef.afterDismissed();
  }
}

export interface DataConfirm {
  theme?: string;
  icon?: string;
  disableClose?: boolean;
  title: string;
  message?: string;
  messageDisable?: boolean;
  formConfig?: any;
  buttonConfirm?: {
    show: boolean;
    label?: string;
  };
  buttonCancel?: {
    show: boolean;
    label?: string;
  };
}
